import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

declare global {
  interface Window {
    __SUPABASE_CONFIG__?: { url: string; key: string };
  }
}

// URL: prefer env (production), then runtime override, then project fallback for dev.
export const SUPABASE_URL =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim() ||
  (typeof window !== "undefined" && window.__SUPABASE_CONFIG__?.url) ||
  "https://iwynllphocgnkkmojluy.supabase.co";

// Key: prefer env (production), then runtime window (index.html), then empty.
export const SUPABASE_ANON_KEY =
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined)?.trim() ||
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim() ||
  (typeof window !== "undefined" && window.__SUPABASE_CONFIG__?.key) ||
  "";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    flowType: "pkce", // Required for reliable OAuth/email callback on app.reviewboost24.com
  },
});
